import React from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { goToPage , reportAnalytics} from '../TechnicianUpdatesBlockSlice';
import SuccessMsg from '../Shared/SuccessMsg/SuccessMsg';

const SuccessPage = (props) => {

  useExtendedEffect((runSideEffects) => { 
    window.scrollTo(0, 0);

    if (runSideEffects()) {
      if(props.successPageType == "update"){
        props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_8", eventLabel: "element_9"});
      }
      else{
          props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_11", eventLabel: "element_13"});
      }
    }
  }, []);


  function onClickBtn(){
    props.goToPage("customerVisitInfoPage");
  }
 
  return (
    <div className='technician-update-error-page'>
      <SuccessMsg onClickBtn={onClickBtn}/>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    successPageType: state.technicianUpdatesBlock.successPageType
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
